import { render, staticRenderFns } from "./uploadText.vue?vue&type=template&id=dc1a50cc"
import script from "./uploadText.vue?vue&type=script&lang=js"
export * from "./uploadText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports